/**
 * Created by matheusmorett on 22/08/17.
 */
import Footer from './Footer';
export default Footer;
